<template>
	<div class="similar-brands">
		<div class="similar-brands__content container">
			<div class="top flex al-center between">
				<div class="similar-brands__title font-23 bold uppercase">
					{{ _.get(contentData, 'conf.header.title') }}
				</div>
				<a
					v-if="_.get(contentData, `conf.header.full_list_url`)"
					:href="_.get(contentData, `conf.header.full_list_url`)"
					class="view-all uppercase pointer"
				>
					{{ _.get(contentData, 'conf.header.full_list_title') }}

					<svg xmlns="http://www.w3.org/2000/svg" width="7.857" height="10" viewBox="0 0 7.857 10">
						<path
							id="Icon_material-play-arrow"
							data-name="Icon material-play-arrow"
							d="M12,7.5v10l7.857-5Z"
							transform="translate(-12 -7.5)"
							fill="#4d4d4f"
						/>
					</svg>
				</a>
			</div>

			<swiper ref="slider" class="similar-brands-slider" :options="swiperOptions">
				<swiper-slide
					class="single-slide"
					v-for="(item, index) in _.get(contentData, 'data.list')"
					:key="index"
				>
					<div class="brand">
						<div class="flex al-center">
							<div class="logo">
								<picture>
									<source
										media="(max-width: 767px)"
										:srcset="_.get(item, 'logo[0].devices.mobile')"
									/>
									<source
										media="(max-width: 1023px)"
										:srcset="_.get(item, 'logo[0].devices.tablet')"
									/>
									<img :src="_.get(item, 'logo[0].devices.desktop')" alt />
								</picture>
							</div>
							<div class="title bold font-21">
								{{ _.get(item, 'front_title') }}
							</div>
						</div>
						<div class="work-hours bold">
							{{ $fn.tr('სამუშაო საათები') }} : {{ _.get(item, 'working_hours[0].hrs[0]') }} -
							{{ _.get(item, 'working_hours[0].hrs[1]') }}
						</div>
						<router-link
							class="row more flex al-center bold uppercase pointer"
							:to="$store.getters['main/getSingleUrl'](item)"
						>
							{{ $fn.tr('ვიზიტი') }}
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="7.857"
								height="10"
								viewBox="0 0 7.857 10"
							>
								<path
									id="Icon_material-play-arrow"
									data-name="Icon material-play-arrow"
									d="M12,7.5v10l7.857-5Z"
									transform="translate(-12 -7.5)"
									fill="#4d4d4f"
								/>
							</svg>
						</router-link>
					</div>

					<!-- <offer-card :offer="offer" /> -->
				</swiper-slide>
			</swiper>
			<div class="swiper-navigation-button white swiper-prev swiper-prev-brand">
				<svg xmlns="http://www.w3.org/2000/svg" width="7.857" height="10" viewBox="0 0 7.857 10">
					<path
						id="Icon_material-play-arrow"
						data-name="Icon material-play-arrow"
						d="M12,7.5v10l7.857-5Z"
						transform="translate(-12 -7.5)"
						fill="#fff"
					/>
				</svg>
			</div>

			<div class="swiper-navigation-button white swiper-next swiper-next-brand">
				<svg xmlns="http://www.w3.org/2000/svg" width="7.857" height="10" viewBox="0 0 7.857 10">
					<path
						id="Icon_material-play-arrow"
						data-name="Icon material-play-arrow"
						d="M12,7.5v10l7.857-5Z"
						transform="translate(-12 -7.5)"
						fill="#fff"
					/>
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['contentData'],
	data() {
		return {
			swiperOptions: {
				speed: 800,
				slidesPerView: 3,
				spaceBetween: 30,
				watchOverflow: true,
				navigation: {
					nextEl: '.similar-brands .swiper-next-brand',
					prevEl: '.similar-brands .swiper-prev-brand',
				},
				breakpoints: {
					320: {
						slidesPerView: 1,
					},
					510: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 2,
					},
					1023: {
						slidesPerView: 3,
					},
				},
			},
		};
	},
};
</script>

<style lang="scss">
.similar-brands {
	background: #f7f7f7;
	padding: 89px 0;
	@media (max-width: 767px) {
		padding: 55px 0 125px;
	}
	&__content {
		position: relative;
	}
	.view-all {
		color: $black;
	}
	.swiper-navigation-button {
		top: calc(50% + 40px);
		@media (max-width: 767px) {
			top: unset;
		}
	}
	.top {
		padding-bottom: 55px;
	}
	.similar-brands-slider {
		.swiper-slide {
			height: unset;
		}
		.brand {
			border: 2px solid #dbdbdb;
			padding-left: 60px;
			padding-top: 30px;
			padding-bottom: 38px;
			padding-right: 10px;
			height: 100%;
			background: $white;
			line-break: anywhere;

			@media (max-width: 1439px) {
				padding-left: 20px;
			}
			.logo {
				width: 60px;
				height: 60px;
				min-width: 60px;
				border-radius: 10px;
				position: relative;
				padding: 0 8px;
				background: #f7f7f7;
				img {
					position: absolute;
					width: 70%;
					height: 100%;
					object-fit: contain;
				}
			}
			.work-hours {
				color: #4d4d4f;
				padding: 21px 0 25px;
			}
			.title {
				margin-left: 10px;
			}
			.more {
				color: $black;
				transition: 0.4s ease-in-out;
				&:hover {
					color: #e50b09;
					svg {
						path {
							fill: #e50b09;
						}
					}
				}
				svg {
					margin-left: 10px;
					path {
						transition: 0.4s ease-in-out;
					}
				}
			}
		}
	}
}
</style>
